import React, { useState } from 'react'
import SelectTree from '../SelectTree'
import Typography from '../Typography'
import { Popover } from 'antd'
import FilterMenu from '../FilterMenu'
import './sort-and-filter-menu.scss'

interface SortAndFilterMenuProps {
    treeData: any[]
    children: React.ReactNode
    treeValue: string | undefined
    handleTreeChange: (value?: string) => void
    onApplyFilters: () => void
    onClear: () => void
    showLabel?: boolean,
    style?: React.CSSProperties,
    treeStyle?: React.CSSProperties
    allowClearTree?: boolean
}

export default function SortAndFilterMenu({
    treeData,
    children,
    treeValue,
    handleTreeChange,
    onApplyFilters,
    onClear,
    showLabel = true,
    style,
    treeStyle,
    allowClearTree = true
}: SortAndFilterMenuProps) {

    const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false)
    return (
        <div className="sort-and-filter" style={style}>
            {showLabel && <Typography variant="subHeading-3" style={{ minWidth: "fit-content" }}>Sort By:</Typography>}
            <SelectTree
                className='call-center-sort-select'
                treeData={treeData}
                value={treeValue}
                onChange={handleTreeChange}
                placeholder="Default"
                containerStyle={treeStyle}
                allowClear={allowClearTree}
            />
            <Popover
                placement="bottomRight"
                trigger="click"
                onOpenChange={(open) => setIsFilterMenuOpen(open)}
                open={isFilterMenuOpen}
                styles={{ body: { padding: 0 } }}
                content={<FilterMenu onClose={() => setIsFilterMenuOpen(false)} onApply={onApplyFilters} onClear={onClear}>{children}</FilterMenu>}
            >
                <div onClick={() => setIsFilterMenuOpen(true)} className="filter-button-container">
                    <div className="filter-icon-container">
                        <i className="bx bx-slider"></i>
                    </div>
                </div>
            </Popover>
        </div>
    )
}
